var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col w-100" },
    [
      _c(
        "div",
        { staticClass: "row justify-content-center w-100 pt-4" },
        [
          _c(
            "pui-tabs",
            {
              attrs: { selected: _vm.currentTab },
              on: { changed: _vm.toggle },
            },
            _vm._l(_vm.tabs, function (tab) {
              return _c("pui-tab", { key: tab, attrs: { title: _vm.$t(tab) } })
            }),
            1
          ),
        ],
        1
      ),
      _vm.currentTab === 0 ? _c("outage-clock") : _vm._e(),
      _vm.currentTab === 1 ? _c("outage-scorecard") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }